import SearchSelect from '../search-select'
import ErrorValidation from '../personalized/error-validation'
import { __ } from '../../../locales'

const profileTypeLabels = {
    practice: 'global.practice',
    specialist: 'global.clinician'
}

const ProfileFilters = ({
    inputs,
    changeProfileType,
    profileTypes,
    profilesList,
    selectedProfiles,
    addProfile,
    removeProfile,
    onAutocompleteSearch = () => {},
    prepopulated,
}) => {
    return (
        <>
            {prepopulated ? null : (
                <div className={'input-component'}>
                    <label>{__('global.profile_type')}:</label>
                    <select
                        required
                        disabled={prepopulated}
                        className="form-control"
                        value={inputs.profileType}
                        onInput={(ev) => changeProfileType(ev.target.value)}
                    >
                        {profileTypes.map(type => (
                            <option value={type}>
                                {profileTypeLabels?.[type] ? __(profileTypeLabels[type]) : type}
                            </option>
                        ))}
                    </select>
                    {!inputs.profileType ? (
                        <ErrorValidation style={{ position: 'absolute', top: '78px' }} />
                    ) : null}
                </div>
            )}
            {inputs.profileType ? (
                <SearchSelect
                    required
                    disabled={prepopulated}
                    title={__('inputs.profile_name.label')}
                    options={profilesList}
                    value={selectedProfiles}
                    onAutocompleteSearch={onAutocompleteSearch}
                    onChange={addProfile}
                    multiple={!prepopulated}
                    onRemove={removeProfile}
                />
            ) : null}
        </>
    )
};

export default ProfileFilters;
